type PseudoRoute = {
  fullPath: string;
  query: Record<string, unknown>;
};

type PseudoMiddlewareDependencies = {
  abort: () => unknown;
  activatePseudo: (pseudoId: string) => void;
  clearPseudoContexts: () => void;
  getSystemAdminStatus: () => Promise<boolean | undefined>;
  navigateToLogin: (redirect: string) => unknown;
  origin: string;
  replaceLocation: (url: string) => void;
};

export const handlePseudoRoute = async (
  to: PseudoRoute,
  dependencies: PseudoMiddlewareDependencies
) => {
  if (to.query.pseudo === undefined) return;

  const cleanLocation = new URL(to.fullPath, dependencies.origin);
  cleanLocation.searchParams.delete("pseudo");
  const cleanUrl = `${cleanLocation.pathname}${cleanLocation.search}${cleanLocation.hash}`;

  const replaceWithCleanUrl = () => {
    dependencies.replaceLocation(cleanUrl);
    return dependencies.abort();
  };

  const pseudoId = to.query.pseudo;

  if (typeof pseudoId !== "string" || !pseudoId.trim()) {
    dependencies.clearPseudoContexts();
    return replaceWithCleanUrl();
  }

  const isSystemAdmin = await dependencies.getSystemAdminStatus();

  if (isSystemAdmin === undefined) {
    return dependencies.navigateToLogin(to.fullPath);
  }

  dependencies.clearPseudoContexts();

  if (isSystemAdmin) {
    dependencies.activatePseudo(pseudoId);
  }

  return replaceWithCleanUrl();
};
